import { EnvironmentConfig } from '../services/environmentService';

export function createAmplifyConfig(envConfig: EnvironmentConfig) {
  return {
    Auth: {
      Cognito: {
        userPoolId: envConfig.userPoolId,
        userPoolClientId: envConfig.userPoolClientId,
        region: envConfig.region,

        // OAuth configuration for Microsoft Entra and Cognito Hosted UI
        loginWith: {
          oauth: {
            domain: envConfig.authDomain,
            scopes: envConfig.oauthScopes,
            redirectSignIn: envConfig.oauthRedirectSignIn,
            redirectSignOut: envConfig.oauthRedirectSignOut,
            responseType: 'code' as const,
            providers: [{ custom: 'MicrosoftEntra' }], // Microsoft Entra provider configured in CDK
          },
        },
      },
    },
    API: {
      REST: {
        ToolsAPI: {
          endpoint: envConfig.apiUrl,
          region: envConfig.region,
        },
      },
    },
  };
}
